// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_liveCard__Ct4wS{
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    border-radius: 8px;
    height: 500px;
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/videos/styles.module.css"],"names":[],"mappings":"AAAA;IACI,uFAAuF;IACvF,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".liveCard{\n    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n    border-radius: 8px;\n    height: 500px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"liveCard": `styles_liveCard__Ct4wS`
};
export default ___CSS_LOADER_EXPORT___;
